<template>
<div id="mainBlock">
    <div id="blackPanel"></div>
    <article>
        <section>
            <div id="subHeader">

                <!-- 企業名を表示 -->
                <h2 v-if="siteInfo !== null">{{siteInfo[0]['site_name']}}</h2>

                <!-- 実行結果のモーダル -->
                <Alert
                    ref="Alert"
                    :message="alertMessage"
                    :subMessage="alertSubMessage"
                    :errorFlag="errorFlag"
                    @confirmFinished="confirmFinished"
                />
            </div>
        </section>

        <!-- サムネイル表示のためのコンポーネント呼び出し -->
        <LiveLists v-if="siteInfo !== null && cameraInfo !== null" :thumbnailSize="selectedThumbnailSize" :siteInfo="siteInfo" :cameraInfo="cameraInfo" :imgUrlCamera="imgUrl" @modalOpen="modalOpen" />

        <!-- 動画再生モーダル表示のためのコンポーネント呼び出し -->
        <LiveModal v-if="siteInfo !== null && cameraInfo !== null && modal" :videoUrlList="videoUrlList" :selectedMovie="selectedMovie" :selectVideo="selectVideo" @close="modalClose" />
    </article>
</div>
</template>
<script>
import LiveLists from './LiveLists.vue'
import LiveModal from '../modal/LiveModal.vue'
import commonValidationCheck from '../../js/modules/componentCommonValidationCheck.js'
import componentScrollControl from '../../js/modules/componentScrollControl.js'
import componentModalCenter from '../../js/modules/componentModalCenter.js'
import componentUrlControl from '../../js/modules/componentUrlControl.js'
import Alert from '../modal/Alert'
const logoutUrl = process.env.VUE_APP_TOP_PAGE_URL;
const apiUrl = process.env.VUE_APP_API_apiUrl;

export default {
    name: 'LiveMain',
    data() {
        return {
            // 選択した端末の端末IDおよびLIVE映像を格納
            selectVideo: {},

            // サムネイル画像の表示サイズを保持するために使用
            selectedThumbnailSize: 'medium',

            // 端末取得APIで取得した端末一覧
            cameras : [],

            // サムネイル最新画像格納場所
            imgUrl: [],

            // カメラ情報を保持しメイン部分のカメラ名を表示に使用
            liveList: [],

            // サムネイルAPIで取得したデータ配列
            liveImg : [],

            // サムネイル最新画像を配置する配列
            cameraList: [],

            // モーダルに渡す動画URL情報の配列（動画再生エンドポイントURLなどを格納）
            videoUrlList : [],

            // 動画再生のために選択された動画を特定するための値
            selectedMovie : null,

            // モーダルの開閉に使用するための値
            modal: false,

            // ローディング画面を表示するための値
            is_show: false,

            // 実行結果のモーダル関連
            alertMessage: '',
            alertSubMessage: '',
            errorFlag: false
        }
    },
    props: {
        // 親コンポーネントより、現場情報を取得
        siteInfo:{
            type: Array
        },
        // 親コンポーネントより、端末情報を取得
        cameraInfo:{
            type: Array
        }
    },
    components: {
        LiveLists,
        LiveModal,
        Alert,
    },
    methods: {
        /**********************************************************/
        // 動画取得API実施
        /**********************************************************/
        // 引数
        // term_id  : 選択中の端末情報
        // i        : 選択したサムネイルの番号
        /**********************************************************/
        getLiveUrl(camera, i) {
            var querieslive = { live_access_token: this.$store.getters['auth/getLiveAccessToken'], platform_term_id: camera.term_id};
            // vuex経由でaxiosで叩く
            this.$store.dispatch('requestApi/getApiInfoAction', {
                url: apiUrl + 'streams/live/' + this.siteInfo[0].site_no + '/' + camera.term_id  + '/endpoint',//eslint-disable-line
                params: querieslive
            }).then(response => {//eslint-disable-line
                // 選択された端末の動画取得のためのエンドポイントを取得
                this.videoUrlList.splice(i, 1, this.$store.getters["requestApi/getApiInfo"]);
            }, error => {// eslint-disable-line
                this.videoUrlList.splice(i, 1, [{platform_term_id:camera.term_id,endpoint_url: false}]);
                if (error == "Error: Request failed with status code 401") {
                    sessionStorage.clear();
                    window.localStorage.removeItem('TodoApp');
                    this.showResultMessage({
                        transitionLogoutPageFlg: true,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"エラー",
                        sub_message:"トップページに戻ります。",
                        errorFlag: true
                    });
                } else if (error == "Error: Request failed with status code 403") {
                    this.showResultMessage({
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: true,
                        execFlg: false,
                        message:"権限エラー",
                        sub_message:"アクセス権がありません。",
                        errorFlag: true
                    });
                } else {
                    this.modalClose();
                    this.showResultMessage({
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"映像取得エラー",
                        sub_message:"映像が取得できませんでした。",
                        errorFlag: true
                    });
                }
            }).finally(() => {
                // 選択された端末の番号を保持する
                // 例）LiveModalコンポーネントに選択された端末情報を渡す
                this.selectedMovie = i;
            })
        },

        //**********************************************************/
        // カメラのサムネイル画像取得用のAPIの実施
        /***********************************************************/
        // 引数
        // siteInfo: 現場情報
        // cameraInfo：カメラに関する一覧情報
        /***********************************************************/
        async getThumbnailInfo(siteInfo, cameraInfo) {
            // 最新画像を子コンポーネント（LiveLists.vue）に渡すために変数登録
            if(commonValidationCheck.isArray(cameraInfo) && typeof cameraInfo !== "undefined" && cameraInfo.length !== 0){
                this.imgUrl = cameraInfo
            }
        },

        /**********************************************************/
        // ライブ再生 & モーダル開く
        /**********************************************************/
        // 子コンポーネント：LiveLists.vueで
        // サムネイルをクリックした時に動く関数 & モーダルを開く
        /**********************************************************/
        // 引数
        // selectVideo     : 選択したサムネイル番号の配列データ
        /**********************************************************/
        modalOpen(selectVideo) {
            window.history.pushState(null, null, this.$route.path + "?site_no=" + this.$store.getters['auth/getSiteNo'] + '&modal=open&key=' + selectVideo.key + '&term_id=' + selectVideo.term_id);

            // 動画再生モーダルを表示させる
            this.modal = true

            // ビュー全体がレンダリングされるまで待つ
            this.$nextTick(function () {
                componentScrollControl.no_scroll();
                componentModalCenter(".modal-window");
                document.getElementById('page_top').style.display = 'none';
                document.getElementById('Header').style.zIndex = "0";
            })

            // 選択された端末IDをオブジェクトに格納
            this.selectVideo = selectVideo;

            // 初回動画再生時に動画再生エンドポイントURLを格納した配列が空であるための処理
            if(this.videoUrlList.length == 0){
                this.getLiveUrl(selectVideo, selectVideo.key);
            }
            // 初回以降の動画再生処理
            else{
                // 動画再生のためのエンドポイントURLを取得
                var video = this.videoUrlList[0][0];
                // 動画再生のためのエンドポイントURLが取得できた時の処理
                if(video.endpoint_url !== false){
                    this.selectedMovie = selectVideo.key;
                }
                this.getLiveUrl(selectVideo, selectVideo.key);
            }
        },

        /**********************************************************/
        // モーダル閉じる
        /**********************************************************/
        // modalデータをfalseにすることによってモーダルを閉じる
        // LiveModal.vue の 「@click.self="$emit('close')"」より実行
        /**********************************************************/
        modalClose() {
            window.history.pushState(null, null, this.$route.path + "?site_no=" + this.$store.getters['auth/getSiteNo']);
            this.modal = false
            this.$nextTick(function () {
                document.getElementById('page_top').style.display = '';
                document.getElementById('Header').style.zIndex = '';
            })
        },

        /**********************************************************/
        // 実行結果のモーダルを表示
        /**********************************************************/
        showResultMessage(result) {
            this.$refs.Alert.showConfirm();
            this.alertMessage = result.message;
            this.alertSubMessage = result.sub_message;
            this.conrfirmResult = result
            this.errorFlag = result.errorFlag;
        },

        /**********************************************************/
        // 実行結果のモーダルのボタンを押下時の処理
        /**********************************************************/
        confirmFinished() {
            if (this.conrfirmResult.transitionLogoutPageFlg) {
                sessionStorage.clear();
                window.location.href = logoutUrl;
            }
            if (this.conrfirmResult.transitionTopPageFlg) {
                window.location.href = '/home?site_no=' + this.$store.getters['auth/getSiteNo'];
            }
            if (this.conrfirmResult.execFlg) {
                this.getThumnailImageInfo();
            }
        },
    },
    async mounted() {
        await this.getThumbnailInfo(this.siteInfo[0]['site_no'], this.cameraInfo);

        this.$emit('loadFinish');

        // クエリパラメータをチェックしてLIVEモーダルを開いた状態から開始するか判定
        var url = location.pathname + location.search;
        var path = this.$route.path + "?site_no=" + this.$store.getters['auth/getSiteNo'] + '&modal=open';
        var queries = componentUrlControl.url_check(url, path);
        if ('modal' in queries && 'key' in queries && 'term_id' in queries) {
            var selectVideo = {key: Number(queries.key), term_id: Number(queries.term_id)}
            this.modalOpen(selectVideo);
        }
    },
}
</script>

<style lang="scss" scoped>
</style>